<template>
  <div>
    <header-component />
    <div
      class="content padding-t"
      :class="{'padding-t-l': balanceNotification}"
    >
      <slot />
    </div>
  </div>
</template>

<script>
import HeaderComponent from '@/components/HeaderComponent.vue';
import NavMenu from '@/components/NavMenu.vue';
import {mapState} from 'pinia';
import {useModalStore} from '@/stores/modal.js';

export default {
  name: 'BalanceOnly',
  components: {NavMenu, HeaderComponent},
  computed: {
    ...mapState(useModalStore, ['balanceNotification']),
  },
};
</script>
